import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Alert, Button } from 'reactstrap';
import Logo from '../../Assets/images/logo.png'
import '../../Assets/css/--page-login.css'
import { postLogin } from '../../Utilities/Requests';

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ username: "", password: "", apiError: "" });
  const history = useNavigate();

  const validateSubmit = (e) => {
    e.preventDefault();
    resetErrors();
    const error = { username: "", password: "", apiError: "" }
    let flag = false;
    if (!username || username.replaceAll(/\s/g, '').length < 3 || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(username)) {
      error.username = 'Please provide a valid email address';
      flag = true
    }
    if (!password || password.replaceAll(/\s/g, '').length < 6) {
      error.password = 'Please provide a valid password';
      flag = true
    }
    setErrors(error);
    if (!flag) {
      setLoading(true)
      postLogin("/auth/user", { email: username, password: password }).then(( data ) => {
        localStorage.setItem("TOKEN_KEY", data.data.token)
        // localStorage.setItem("user", JSON.stringify({ name: data.fullName, picture: data.profilePictureUrl }))
        history('/dashboard');
      }).catch((e) => {
        const error = { username: "", password: "", apiError: e }
        setErrors(error);
        resetForm();
        setLoading(false)
      })
    }
  }

  const resetForm = () => {
    setUsername("");
    setPassword("");
  }
  const resetErrors = () => {
    const error = { username: "", password: "", apiError: "" }
    setErrors(error);
  }
  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md="6" lg="4">
            <div className="logo-container text-center mb-4">
              <img src={Logo} alt="Logo" />
            </div>
            <Card className="shadow-sm">
              <CardBody>
                <h5 className="fw-600">Login to account</h5>
                <p className="fw-300 text-light fs-14">Enter your email & password to login</p>
                {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}
                <form onSubmit={validateSubmit}>
                  <FormGroup>
                    <Label className='fw-600' for="email">Email address</Label>
                    <Input type="email" id="email" value={username} onChange={(e) => { setUsername(e.target.value) }} placeholder="Enter your email address" />
                    {errors.username ? <div className="invalid-feedback">{errors.username}</div> : null}
                  </FormGroup>
                  <FormGroup>
                    <Label className='fw-600' for="password">Password</Label>
                    <Input type="password" id="password" value={password} onChange={(e) => { setPassword(e.target.value) }} placeholder="Enter your password" />
                    {errors.password ? <div className="invalid-feedback">{errors.password}</div> : null}
                  </FormGroup>
                  <button disabled={loading} type='submit' className='btn btn-primary w-100'>{loading ? "Please Wait" : "Login"}</button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

